module.exports = __webpack_public_path__ + "static/media/inside-right.0a969bc9.svg";